import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import ReportAIServiceV2 from './ReportAIServiceV2';
import { ReportExecutionResult } from '@/models/reportAI';

const reportAIService = ReportAIServiceV2.getInstance();

export const REPORT_AI_QUERY_KEYS = {
    DEFINITIONS: 'REPORT_AI_DEFINITIONS',
    EXECUTE: 'REPORT_AI_EXECUTE'
};

export const useReportDefinitions = (companyId: string, enabled = true) =>
    useQuery({
        queryKey: [REPORT_AI_QUERY_KEYS.DEFINITIONS, companyId],
        queryFn: async () => {
            const res = await reportAIService.getDefinitions(companyId);
            return res.data;
        },
        enabled: enabled && !!companyId,
        retry: false,
        staleTime: 60_000
    });

export const useDeleteDefinition = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (reportId: string) =>
            reportAIService.deleteDefinition(reportId),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [REPORT_AI_QUERY_KEYS.DEFINITIONS]
            });
        }
    });
};

export const useExecuteReport = (
    reportId: string,
    companyId: string,
    params: Record<string, string | undefined>,
    enabled = false
) =>
    useQuery<ReportExecutionResult>({
        queryKey: [REPORT_AI_QUERY_KEYS.EXECUTE, reportId, params],
        queryFn: async () => {
            const res = await reportAIService.executeReport(
                reportId,
                companyId,
                params
            );
            return res.data;
        },
        enabled: enabled && !!reportId && !!companyId,
        retry: false
    });
